import { css, Stack, styled, Typography } from '@mui/material';
import { Popup } from '@vis.gl/react-maplibre';

import { PopupContent } from '@/components/PopupContent';

export const SmallTypography = styled(Typography)(
  () => css`
    font-size: 0.825rem;
  `,
);
interface LayerPopupProps {
  title: string;
  content: string;
  coordinates: [number, number];
  onClose: () => void;
}

export function LayerPopup({ title, content, coordinates, onClose }: LayerPopupProps) {
  return (
    <Popup
      closeOnClick
      anchor="bottom-left"
      closeButton={false}
      latitude={coordinates[1]}
      longitude={coordinates[0]}
      maxWidth="350 px"
      offset={0}
      onClose={onClose}
    >
      <PopupContent>
        <Stack gap={0.5}>
          <Typography variant="body1">{title}</Typography>
          <SmallTypography variant="body2">{content}</SmallTypography>
        </Stack>
      </PopupContent>
    </Popup>
  );
}
